export default __webpack_public_path__ + "static/media/1-min.ffbc3425.jpg";